import styled from "styled-components";

const MaterialUiDropdownWrapper = styled.div`
  position: relative;
  .materialUi__dropdown--toggle {
    border-radius: 5px;
    text-transform: unset;
    white-space: nowrap;
    &:disabled {
      opacity: 0.6;
    }
  }
  .materialUi__dropdown--menu {
    margin-top: 1px;
    z-index: 1000;
    min-width: 160px;
    color: #212529;
    font-size: 14px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    list-style: none;
    background-clip: padding-box;

    ul li {
      font-size: 14px;
    }
  }
`;

export default MaterialUiDropdownWrapper;
